/**
 * Octopus IoT Platform - Alert Config API Service (Fase 1000)
 *
 * Cliente do endpoint singleton por equipamento `db.equipment_alert_config`
 * (Plan 01): GET devolve defaults preenchidos quando o doc ainda não existe;
 * PUT escreve SOMENTE a seção enviada no payload ($set dot-notation por
 * seção no backend) — nunca apaga as demais seções (999.4-03).
 */
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * @param {string} equipmentId
 */
export const getAlertConfig = (equipmentId) =>
  axios.get(`${API}/equipments/${equipmentId}/alert-config`);

/**
 * @param {string} equipmentId
 * @param {object} sectionPayload - só a(s) seção(ões) editada(s), ex.:
 *   { engine_notification: { phones: [...], emails: [...] } }
 */
export const putAlertConfig = (equipmentId, sectionPayload) =>
  axios.put(`${API}/equipments/${equipmentId}/alert-config`, sectionPayload);

const alertConfigApi = { getAlertConfig, putAlertConfig };

export default alertConfigApi;
